import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Textarea from '../../styles/common/Textarea';
import ColorSF2 from '../../styles/common/ColorSF2';

const MyTextarea = styled(Textarea)`
  width: ${props => props.width};
  height: ${props => props.height};
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 4px;
`;
const CountLabel = styled.p`
  font-size: 10px;
  color: ##2f2f2f;
  text-align: end;
`;

/**
 * 入力文字数カウント付きテキストエリアコンポーネント
 * @component
 */
const TextareaWithCount = ({
  value,
  width,
  height,
  maxLength,
  onChange,
  disabled,
  placeholder,
}) => {
  const count = `${value.length}/${maxLength}`;
  return (
    <Fragment key="TextareaWithCount">
      <MyTextarea
        width={width}
        height={height}
        value={value}
        maxLength={maxLength}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
      />
      <CountLabel>{count}</CountLabel>
    </Fragment>
  );
};

TextareaWithCount.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};
TextareaWithCount.defaultProps = {
  width: '100%',
  height: '100%',
  maxLength: undefined,
  disabled: false,
  placeholder: '',
};

export default TextareaWithCount;
